import React, { useCallback, useContext, useEffect, useState } from 'react';
import WrapOne from '../../../assets/wrapOne.png';
import WrapTwo from '../../../assets/wrapTwo.png';
import WrapThree from '../../../assets/wrapThree.png';
import SignedInNavbarImproved from '../../SignedInNavbarImproved';
import { Transition } from '@headlessui/react';
import { IoInformationCircleSharp } from 'react-icons/io5';
import Tooltip from "@mui/material/Tooltip";
import { Tab } from "@headlessui/react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../services/authService';
import RxjsGiftStoreContext from '../../../context/RxjsGiftStoreContext';
import RxjsStoreContext from '../../../context/RxjsStoreContext';
import {
    activePlans,
    activePlansUpdated,
    cartItemDelete,
    cartItemsDelete,
    fetchCountries,
    fetchGrocedyForAll,
    fetchRecommendations,
    getAllGiftReceipients,
    getDelivery,
    getProductReceipient,
    getTransactions,
    getWalletBalance,
    handleCheckoutHybrid,
    handleCheckoutHybridDelivery,
    productPurchaseGet,
    productPurchaseSet,
    todoListStatus,
    verifyCoupon
} from '../../../store/actions';
import { resetCoupon, setCustomBasketRemark, setGiftCustomBasketRemark, setGiftFoodBasketRemark } from '../../../store/slices/cartSlice';
import toast from 'react-hot-toast';
import { updateCart } from '../../../core/utils/CartHelpers';
import { setIsSubmiting } from '../../../store/slices/modalSlice';
import RxjsFoodBasketContext from '../../../context/RxjsFoodBasketContext';
import Modal from '../../Ui';
import MyCartCheckout from './MyCartCheckout';
import GiftCartCheckout from './GiftCartCheckout';
import MyCartSummary from './MyCartSummary';
import GiftCartSummary from './GiftCartSummary';
import GiftModal from './Popups/GiftModal';
import GiftItemModal from './Popups/GiftItemModal';
import CustomGiftRecipientDetailsModal from './Popups/CustomGiftReceipientModal';
import FBGiftRecipientModal from './Popups/FBGiftRecipientModal';
import ChangeRecipient from './Popups/ChangeRecipient';
import { Modal as MUIModal, Box } from "@mui/material";
import FeedBackRatingPopup from '../../Rating/FeedBackRatingPopup';

const CheckoutPage = () => {
    const rxjsStore = useContext(RxjsStoreContext);
    const rxjsGiftStore = useContext(RxjsGiftStoreContext);
    const rxjsFoodBasketStore = useContext(RxjsFoodBasketContext);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const copyCartObj = JSON.parse(localStorage.getItem("cart"));
    const { customBasketRemark } = useSelector((state) => state.cart);
    const { giftFoodBasketRemark } = useSelector((state) => state.cart);
    const { giftCustomBasketRemark } = useSelector((state) => state.cart);

    // localstorage handling the custom basket recurr
    const customBasketIsRecurring = localStorage.getItem("custom_isrecurring");
    const customIsInfinite = localStorage.getItem("custom_isInfinite");
    const customRecurrMonths = localStorage.getItem("custom_recurr_months");

    // localstorage handling the gift foodbasket recurr
    const giftFoodBasketIsRecurring = localStorage.getItem("gift_foodbasket_isrecurring");
    const giftFoodBasketIsInfinite = localStorage.getItem("gift_foodbasket_isInfinite");
    const giftFoodBasketRecurrMonths = localStorage.getItem("gift_foodbasket_recurr_months");

    // localstorage handling the gift custom recurr
    const giftCustomIsRecurring = localStorage.getItem("gift_custom_isrecurring");
    const giftCustomIsInfinite = localStorage.getItem("gift_custom_isInfinite");
    const giftCustomRecurrMonths = localStorage.getItem("gift_custom_recurr_months");

    // const isFrom = localStorage.getItem("isFrom");
    const [tabIndex, setTabIndex] = useState(0)
    const [fetchedCart, setFetchedCart] = useState({});
    const [fetchedPlans, setFetchedPlans] = useState([]);
    const [customBasket, setCustomBasket] = useState({});
    const [fetchedExistingAddress, setFetchedExistingAddress] = useState([]);
    const [customGiftBasket, setCustomGiftBasket] = useState({});
    const [customGiftFoodBasket, setCustomGiftFoodBasket] = useState({});
    const [subTotalPlanPrice, setSubTotalPlanPrice] = useState(0);
    const [subTotalOfflinePlanPrice, setSubTotalOfflinefPlanPrice] = useState(0);
    const [subTotalAddonPrice, setSubTotalAddonPrice] = useState(0);
    const [subTotalOfflineAddonPrice, setSubTotalOfflineAddonPrice] = useState(0);
    const [_, setCounter] = useState(0);
    const [giftCounter, setGiftCounter] = useState(0);
    const [giftFoodBasketCounter, setGiftFoodBasketCounter] = useState(0);
    const [fetchedCountries, setFetchedCountries] = useState();
    const [countries, setCountries] = useState();
    const [existingDeliveryInfo, setExistingDeliveryInfo] = useState();
    const [couponCode, setCouponCode] = useState("");
    const [couponCodeGift, setCouponCodeGift] = useState("");
    const [updatedLocalCart, setUpdatedLocalCart] = useState(copyCartObj);
    const [modifiedLocalCart, setModifiedLocalCart] = useState([]);
    const [fetchedUserBalance, setFetchedUserBalance] = useState();
    const [fetchedDeliveryCharge, setFetchedDeliveryCharge] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedModal, setSelectedModal] = useState("");
    const [isViewingIndex, setIsViewingIndex] = useState(1);
    const [fetchedStatuses, setfetchedStatuses] = useState("");
    const [open, setOpen] = useState(false);
    const [openRating, setOpenRating] = useState(false);
    const [openCustomRating, setOpenCustomRating] = useState(false);
    const [totalPlansQty, setTotalPlansQty] = useState(0);
    const [totalGiftPlansQty, setTotalGiftPlansQty] = useState(0);
    const [priceAlert, showPriceAlert] = useState(false);
    const [priceAlertGift, showPriceAlertGift] = useState(false);
    const [subRef, setSubRef] = useState("");
    const [openUnverifiedPhone, setOpenUnverifiedPhone] = useState(false);
    const [fetchedRecommendations, setFetchedRecommendations] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedGiftOption, setSelectedGiftOption] = useState(null);
    const [openGiftModal, setOpenGiftModal] = useState(false);
    const [openGiftItemModal, setOpenGiftItemModal] = useState(false);
    const [basketRecurr, setBasketRecurr] = useState(0);
    const [openCustomGiftRecipientDetailsModal, setOpenCustomGiftRecipientDetailsModal] =
        useState(false);
    const [openFoodBasketGiftRecipientDetailsModal, setOpenFoodBasketGiftRecipientDetailsModal] =
        useState(false);
    const [isCoupon, setIsCoupon] = useState(false);
    const [isCouponGift, setIsCouponGift] = useState(false);

    const [fetchedCustomGiftReceipient, setFetchedCustomGiftReceipient] =
        useState({});
    const [personalCartIsCleared, setPersonalCartIsCleared] = useState(false);

    const [basketType, setBasketType] = useState("");

    const [count, setCount] = useState(+customRecurrMonths);
    const [countGiftFb, setCountGiftFb] = useState(+giftFoodBasketRecurrMonths);
    const [countGiftCustom, setCountGiftCustom] = useState(+giftCustomRecurrMonths);

    const [openRecipientDetailsModal, setOpenRecipientDetailsModal] = useState(false);
    const [hybridDeliveryFee, setHybridDeliveryFee] = useState({});
    const [hybridDeliveryFeeGift, setHybridDeliveryFeeGift] = useState({});
    const [deliveryFeeLoading, setDeliveryFeeLoading] = useState(false);
    const [deliveryFeeLoadingGift, setDeliveryFeeLoadingGift] = useState(false);

    const {
        fetchCountriesData,
        getDeliveryItems,
        todoListStatusData,
        grocedyForAll,
    } = useSelector((state) => state.masterData);
    const { cart, coupon } = useSelector((state) => state.cart);
    const { walletBalance } = useSelector((state) => state.user);

    const userEmail = authService.getCurrentUserEmail();
    const selected_plan = localStorage.getItem("selected_plan");

    const verification_code = authService.getCurrentUserVerificationCode();
    const userId = authService.getCurrentUserID();
    const customerId = authService.getCurrentUserCustomerId();
    const zohoCustomerId = authService.getCurrentUserZohoCustomerId();
    const token = authService.getCurrentUserVerificationCode();

    const removeCustomGiftFoodBasket = useCallback(() => {
        localStorage.removeItem("giftFoodBasket");
        rxjsFoodBasketStore.clearCustomBasket();
        setCustomGiftFoodBasket({});
        setGiftFoodBasketCounter((prev) => prev + 1);
    }, [rxjsFoodBasketStore]);

    const removeCustomGiftBasket = useCallback(() => {
        localStorage.removeItem("giftCustomBasket");
        rxjsGiftStore.clearCustomBasket();
        setCustomGiftBasket({});
        setGiftCounter((prev) => {
            return prev + 1;
        });
    }, [rxjsGiftStore])

    const handleRecommendations = useCallback((items) => {
        try {
            if (items?.length) {
                let isBasket = false;
                let isButcher = false;
                let item_type_id;

                items?.filter((item) => {
                    if (item?.type === "BASKET") {
                        isBasket = true;
                    }
                    if (item?.type === "BUTCHER") {
                        isButcher = true;
                    }
                });
                item_type_id =
                    isBasket && isButcher
                        ? "0"
                        : isBasket && !isButcher
                            ? "1"
                            : !isBasket && isButcher
                                ? "2"
                                : "0";

                const itemsIds = items?.map((item) => {
                    return `
              <a><item_id>${item?.item_id}</item_id></a>
              `;
                });
                const xmlStructure = `<root>${itemsIds}</root>`;
                const removedString = removeSpacesAndNewlines(xmlStructure);

                const data = {
                    xml_string_item: removedString,
                    item_type_id,
                };

                const payload = {
                    data,
                    customer_id: customerId,
                };

                dispatch(fetchRecommendations(payload))
                    .unwrap()
                    .then((res) => {
                        if (res?.items?.length) {
                            setFetchedRecommendations(res?.items);
                        }
                    })
                    .catch((err) => err);
            }
        } catch (err) {
            return err;
        }
    }, [customerId, dispatch])

    const handleHistorySingle = async (id) => {
        try {
            dispatch(getProductReceipient(id))
                .unwrap()
                .then((res) => {
                    setFetchedCustomGiftReceipient(res);
                })
                .catch((err) => err);
        } catch (err) {
            return err;
        }
    };

    const handleOnClose = () => {
        setShowModal(false);
        setSelectedModal("");
    };

    function calculateTotalPlansQty(plans) {
        if (plans && plans?.length) {
            const sum = plans?.reduce(
                (acc, item) => acc + Number(item?.JSON_String?.plan?.plan_quantity),
                0
            );

            return sum;
        }
    }

    function calculateTotalGiftPlansQty(plans) {
        if (plans && plans?.length) {
            const sum = plans?.reduce(
                (acc, item) => acc + Number(item?.quantity),
                0
            );

            return sum;
        }
    }

    const handleFetchSavedDelivery = async () => {
        try {
            dispatch(getAllGiftReceipients(customerId))
                .unwrap()
                .then((res) => {
                    setFetchedExistingAddress(res);
                })
                .catch((err) => err);
        } catch (err) {
            return err;
        }
    };


    // Coupon verification
    const handleCouponVerify = (e) => {
        e.preventDefault();
        setIsCoupon(false);

        try {

            const data = {
                coupon_code: couponCode,
                product_id: "1",
            };

            dispatch(verifyCoupon(data))
                .unwrap()
                .then((res) => {
                    if (res?.Result === false) {
                        setIsCoupon(false);
                    }
                    setIsCoupon(true);
                    // return toast.success("Coupon Verified!", { id: toastId });
                })
                .catch((err) => {
                    setIsCoupon(false);

                    return err;
                });
        } catch (e) {
            return e;
        }
    };

    const handleCouponVerifyGift = (e) => {
        e.preventDefault();

        try {
            const toastId = toast.loading("verifying coupon...");

            const data = {
                coupon_code: couponCodeGift,
                product_id: "1",
            };

            dispatch(verifyCoupon(data))
                .unwrap()
                .then((res) => {
                    if (res?.Result === false) {
                        return toast.error("Coupon Could not be verified!", {
                            id: toastId,
                        });
                    }
                    setIsCouponGift(true);
                    return toast.success("Coupon Verified!", { id: toastId });
                })
                .catch((err) => {
                    toast.error("Coupon Could not be verified!", { id: toastId });

                    return err;
                });
        } catch (e) {
            return e;
        }
    };

    // Return to Product list
    // const handleContinue = () => {
    //     navigate(`/home/plans/${selected_plan}`);
    // };

    // Delete Item in a cart
    const handleDelete = (itemId) => {
        try {
            const data = {
                itemId,
                user_email: userEmail,
            };

            dispatch(cartItemDelete(data))
                .unwrap()
                .then((res) => {
                    updateCart(
                        dispatch,
                        productPurchaseGet,
                        calculateTotalPlansQty,
                        setTotalPlansQty
                    );
                    toast.success("Plan deleted from cart!");
                })
                .catch((err) => {
                    toast.error("Something Went Wrong!");

                    return err;
                });
        } catch (e) {
            return e;
        }
    };

    //Delete from the local cart
    // const handleLocalDelete = (itemId) => {
    //     try {
    //         const newUpdatedLocalCart = updatedLocalCart?.filter(
    //             (cartItem) => cartItem?.itemId !== itemId
    //         );

    //         setUpdatedLocalCart(newUpdatedLocalCart);
    //     } catch (e) {
    //         return e;
    //     }
    // };

    // Update local cart
    // const handleLocalCartUpdate = (item) => {
    //     try {
    //         const selectedPlanDetails = fetchedPlans?.filter(
    //             (fPlan) => fPlan?.name === item.plan_name
    //         );

    //         const data = {
    //             plan_name: item.plan_name,
    //             plan_quantity: item.plan_units.toString(),
    //             plan_price: selectedPlanDetails[0]?.recurring_price,
    //             plan_code: selectedPlanDetails[0]?.plan_code,
    //             isRecurring: item.isRecurring,
    //             product_id: selectedPlanDetails[0]?.product_id,
    //             interval: "1",
    //             interval_unit: "months",
    //             number_of_months: item.months_recurring.toString(),
    //         };

    //         const newUpdatedArray = updatedLocalCart;

    //         const target = newUpdatedArray.find((obj) => obj.itemId === item?.itemId);

    //         Object.assign(target, data);

    //         setUpdatedLocalCart(newUpdatedArray);
    //     } catch (e) {
    //         return e;
    //     }
    // };

    const removeCustomBasket = () => {
        rxjsStore.clearCustomBasket();
        dispatch(setCustomBasketRemark(""));
        setCustomBasket({});
        setCounter((prev) => {
            return prev + 1;
        });
    };

    const removeGiftCustomBasket = () => {
        rxjsGiftStore.clearCustomBasket();
        setCustomGiftBasket({});
        dispatch(setGiftCustomBasketRemark(""));
        setCounter((prev) => {
            return prev + 1;
        });
    };

    const removeGiftFoodBasketCustomBasket = () => {
        rxjsFoodBasketStore.clearCustomBasket();
        setCustomGiftFoodBasket({});
        dispatch(setGiftFoodBasketRemark(""));
        setCounter((prev) => {
            return prev + 1;
        });
    };


    const calculateTotalBasket = (basket) => {
        let total = 0;

        if (basket?.line_items?.length) {
            basket.line_items?.forEach((product) => {
                total += product?.item_total;
            });
        }
        return total;
    };

    const handleSelect = (option) => {
        setSelectedOption(option);
    };

    const handleSelectGiftItem = (option) => {
        setSelectedGiftOption(option);
    };

    const handleViewReceipient = () => {
        const id = localStorage.getItem("giftCustomBasket");

        if (id) {
            setOpenCustomGiftRecipientDetailsModal(true);
            handleHistorySingle(id)
        }

    }

    const handleViewFoodBasketReceipient = () => {
        const id = localStorage.getItem("giftFoodBasket");

        if (id) {
            setOpenFoodBasketGiftRecipientDetailsModal(true);
            handleHistorySingle(id)
        }

    }

    const handleTabChange = (index) => {
        setTabIndex(index)
    }

    const changeRecipientFB = () => {
        setOpenRecipientDetailsModal(true);
    };

    const handleGeneralCheckout = async () => {
        if (!token) {
            toast.error("You need to be logged in...");
            return navigate("/login");
        }

        if (
            fetchedStatuses?.phone_number !== "True" ||
            fetchedStatuses?.delivery_address !== "True"
        ) {
            toast.error("Please input all required fields to proceed");
            return setTimeout(() => {
                navigate("/home/todo");
            }, 3000);
        }

        if (fetchedStatuses?.transaction_pin !== "True") {
            toast.error("Please set up transaction pin");
        }

        let amountToPay = 0;

        if (!customBasket?.line_items?.length && !fetchedCart?.items?.length) {
            return toast.error("You have no items in cart...");
        }

        if (customBasket?.line_items?.length) {
            const grandTotalPrice = calculateTotalBasket(customBasket);

            if (grandTotalPrice < 15000) {
                return showPriceAlert(true);
            }
        }

        amountToPay = hybridDeliveryFee?.amount_information?.length && hybridDeliveryFee?.amount_information[0]?.grand_total_amount;

        if (amountToPay > fetchedUserBalance?.available_balance) {
            setShowModal(true);
            return setSelectedModal("insufficient");
        }

        dispatch(setIsSubmiting(false));
        setShowModal(true);
        setSelectedModal("sufficient");
    }

    const handleGiftGeneralCheckout = async () => {
        if (!token) {
            toast.error("You need to be logged in...");
            return navigate("/login");
        }

        if (
            fetchedStatuses?.phone_number !== "True" ||
            fetchedStatuses?.delivery_address !== "True"
        ) {
            toast.error("Please input all required fields to proceed");
            return setTimeout(() => {
                navigate("/home/todo");
            }, 3000);
        }

        if (fetchedStatuses?.transaction_pin !== "True") {
            toast.error("Please set up transaction pin");
        }

        let amountToPay = 0;

        if (!customGiftBasket?.line_items?.length && !customGiftFoodBasket?.line_items?.length) {
            return toast.error("You have no items in cart...");
        }

        if (customGiftBasket?.line_items?.length) {
            const grandTotalPrice = calculateTotalBasket(customGiftBasket);

            if (grandTotalPrice < 15000) {
                return showPriceAlertGift(true);
            }
        }

        amountToPay = hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.grand_total_amount;

        if (amountToPay > fetchedUserBalance?.available_balance) {
            setShowModal(true);
            return setSelectedModal("insufficient");
        }

        dispatch(setIsSubmiting(false));
        setShowModal(true);
        setSelectedModal("sufficient");
    }

    const buildPlanItemsXML = (cartItems) => {
        return cartItems.map((item) => `
    <a>
      <sku>${item?.JSON_String?.plan?.plan_code}</sku>
      <price>${item?.JSON_String?.plan?.plan_price}</price>
      <quantity>${+item?.JSON_String?.plan?.plan_quantity}</quantity>
      <billing_cycles>${+item?.JSON_String?.plan?.number_of_months}</billing_cycles>
      <recuring_infinity>${+item?.JSON_String?.plan?.recuring_infinity}</recuring_infinity>
      <recipient_refno>0</recipient_refno>
    </a>
  `);
    };

    const buildCustomGiftItemsXML = (lineItems, billingCycles, infinityFlag, giftFbRec, remark) => {
        return lineItems.map((item) => `
            <a><sku>${item?.sku}</sku> 
            <price>${item?.rate}</price>
            <quantity>${+item?.quantity}</quantity>
            <billing_cycles>${billingCycles}</billing_cycles> 
            <recuring_infinity>${infinityFlag}</recuring_infinity> 
            <recipient_refno>${giftFbRec}</recipient_refno></a>
            <description>${remark ? remark : " "}</description>
        `);
    };

    const buildCustomItemsXML = (lineItems, billingCycles, infinityFlag, remark) => {
        return lineItems.map((item) => `
    <a>
      <sku>${item?.sku}</sku>
      <price>${item?.rate}</price>
      <quantity>${+item?.quantity}</quantity>
      <billing_cycles>${billingCycles}</billing_cycles>
      <recuring_infinity>${infinityFlag}</recuring_infinity>
      <description>${remark ? remark : ""}</description>
      <recipient_refno>0</recipient_refno>
    </a>
  `);
    };

    function removeSpacesAndNewlines(xml) {
        return xml
            .replace(/\s{2,}/g, '')     // collapse multiple spaces
            .replace(/>\s+</g, '><')    // remove newlines and spaces between tags
            .trim();
    }

    const handleXmlPersonalCart = useCallback((fetchedCart, customBasket) => {
        let basketItemsXML = [];
        let cartItemsXML = [];
        // Plan items
        if (fetchedCart?.items?.length) {
            cartItemsXML = buildPlanItemsXML(fetchedCart.items);
        }

        // Basket items
        if (customBasket?.line_items?.length) {
            const billingCycles = customBasketIsRecurring === "yes" ? customRecurrMonths : 0;
            const infinityFlag = customIsInfinite === "yes" ? 1 : 2;

            basketItemsXML = buildCustomItemsXML(customBasket.line_items, billingCycles, infinityFlag, customBasketRemark);
        }

        // Combine all items into one XML string
        const allItems = [...cartItemsXML, ...basketItemsXML].filter(Boolean);
        const xmlStructure = `<root>${allItems.join('')}</root>`;
        const formattedItems = removeSpacesAndNewlines(xmlStructure);

        return formattedItems;
    }, [customBasketIsRecurring, customBasketRemark, customIsInfinite, customRecurrMonths]);

    const handleXmlGiftCart = useCallback((customGiftFoodBasket, customGiftBasket) => {
        let giftFoodBasketItemsXML = [];
        let giftCustomItemsXML = [];
        const giftFbRec = localStorage.getItem("giftFoodBasket");
        const giftCustomRec = localStorage.getItem("giftCustomBasket");
        // Plan items
        if (customGiftFoodBasket?.line_items?.length) {
            const billingCycles = giftFoodBasketIsRecurring === "yes" ? giftFoodBasketRecurrMonths : 0;
            const infinityFlag = giftFoodBasketIsInfinite === "yes" ? 1 : 2;

            giftFoodBasketItemsXML = buildCustomGiftItemsXML(customGiftFoodBasket?.line_items, billingCycles, infinityFlag, giftFbRec, giftFoodBasketRemark);
        }

        // Basket items
        if (customGiftBasket?.line_items?.length) {
            const billingCycles = giftCustomIsRecurring === "yes" ? giftCustomRecurrMonths : 0;
            const infinityFlag = giftCustomIsInfinite === "yes" ? 1 : 2;

            giftCustomItemsXML = buildCustomGiftItemsXML(customGiftBasket?.line_items, billingCycles, infinityFlag, giftCustomRec, giftCustomBasketRemark);

        }

        // Combine all items into one XML string
        const allItems = [...giftFoodBasketItemsXML, ...giftCustomItemsXML].filter(Boolean);
        const xmlStructure = `<root>${allItems.join('')}</root>`;
        const formattedItems = removeSpacesAndNewlines(xmlStructure);

        return formattedItems;
    }, [giftCustomBasketRemark, giftCustomIsInfinite, giftCustomIsRecurring, giftCustomRecurrMonths, giftFoodBasketIsInfinite, giftFoodBasketIsRecurring, giftFoodBasketRecurrMonths, giftFoodBasketRemark]);

    const handlePersonalSubmission = async (pin) => {
        try {
            if (!pin) return;

            const toastId = toast.loading("Creating your subscription...");

            const payload = {
                customer_id: customerId,
                customer_pin: pin,
                discount_amount: 0,
                coupon_code: couponCode ? couponCode : "",
                item_info: "",
                c_code: 1001,
                user_id: userId,
                user_token: token,
                applicaton_id: 2,
                option: 1,
            };

            const formattedItems = handleXmlPersonalCart(fetchedCart, customBasket);

            const finalPayload = {
                ...payload,
                item_info: formattedItems,
            };

            setShowModal(false);

            const res = await dispatch(handleCheckoutHybrid(finalPayload)).unwrap();

            if (res?.status === 403) {
                dispatch(setIsSubmiting(true));
                setOpenUnverifiedPhone(true);
                handleOnClose();
                return toast.error(res?.message, { id: toastId });
            }

            if (!res?.Result) {
                dispatch(setIsSubmiting(true));
                return toast.error("Subscriptions could not be created...", { id: toastId });
            }

            setPersonalCartIsCleared(true);

            setHybridDeliveryFee({});

            // Subscription success
            dispatch(activePlans(zohoCustomerId));
            dispatch(getTransactions(customerId.toString()));
            setSubRef(res?.Message_Ref_No);

            dispatch(cartItemsDelete({ user_email: fetchedCart?.email }));
            removeCustomBasket();
            setCouponCode("")

            toast.success("Subscription Created...", { id: toastId });
            dispatch(activePlansUpdated(customerId.toString()))
            return setOpenCustomRating(true);
        } catch (err) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    };


    const handleGiftSubmission = async (pin) => {
        try {
            if (pin) {
                const toastId = toast.loading("Creating your subscription...");

                let payload = {
                    customer_id: customerId,
                    customer_pin: pin,
                    discount_amount: 0,
                    coupon_code: couponCodeGift ? couponCodeGift : "",
                    item_info: "",
                    c_code: 1001,
                    user_id: userId,
                    user_token: token,
                    applicaton_id: 2,
                    option: 1,
                };

                const formattedItems = handleXmlGiftCart(customGiftFoodBasket, customGiftBasket)

                const finalPayload = {
                    ...payload,
                    item_info: formattedItems,
                };

                setShowModal(false);

                const res = await dispatch(handleCheckoutHybrid(finalPayload)).unwrap();

                if (res?.status === 403) {
                    dispatch(setIsSubmiting(true));
                    setOpenUnverifiedPhone(true);
                    handleOnClose();
                    return toast.error(res?.message, { id: toastId });
                }

                if (!res?.Result) {
                    dispatch(setIsSubmiting(true));
                    return toast.error("Subscriptions could not be created...", { id: toastId });
                }

                // Subscription success
                dispatch(activePlans(zohoCustomerId));
                dispatch(getTransactions(customerId.toString()));
                setSubRef(res?.Message_Ref_No);

                removeGiftCustomBasket();
                removeGiftFoodBasketCustomBasket();
                localStorage.removeItem("giftCustomBasket");
                localStorage.removeItem("giftFoodBasket");
                setHybridDeliveryFeeGift({});
                setCouponCodeGift("")
                toast.success("Subscription Created...", { id: toastId });
                dispatch(activePlansUpdated(customerId.toString()))

                 return setOpenCustomRating(true);
            }
        } catch (err) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    }

    const calculatePersonalDeliveryFees = useCallback(async (fetchedCart, customBasket) => {
        try {
            setDeliveryFeeLoading(true);
            const payloadDelivery = {
                customer_id: customerId,
                coupon_code: isCoupon ? couponCode : "",
                item_info: "",
                applicaton_id: 2,
                option: 2,
            };

            const formattedItems = handleXmlPersonalCart(fetchedCart, customBasket);

            const finalPayloadDelivery = {
                ...payloadDelivery,
                item_info: formattedItems,
            };

            const resDelivery = await dispatch(handleCheckoutHybridDelivery(finalPayloadDelivery)).unwrap();

            if (resDelivery?.status === 403) {
                dispatch(setIsSubmiting(true));
                setOpenUnverifiedPhone(true);
                handleOnClose();
                return toast.error(resDelivery?.message);
            }

            if (resDelivery?.result_status[0]?.message_id === 3) {
                return toast.error(resDelivery?.result_status[0]?.message_text);
            }

            setDeliveryFeeLoading(false);
            // setCouponCode("");
            return setHybridDeliveryFee(resDelivery);
        } catch (err) {
            return err;
        }
    }, [customerId, dispatch, handleXmlPersonalCart, isCoupon]);

    const calculateGiftDeliveryFees = useCallback(async (customGiftFoodBasket, customGiftBasket) => {
        try {
            setDeliveryFeeLoadingGift(true);

            const payloadDelivery = {
                customer_id: customerId,
                coupon_code: isCouponGift ? couponCodeGift : "",
                item_info: "",
                applicaton_id: 2,
                option: 2,
            };

            const formattedItems = handleXmlGiftCart(customGiftFoodBasket, customGiftBasket);

            const finalPayloadDelivery = {
                ...payloadDelivery,
                item_info: formattedItems,
            };

            const resDelivery = await dispatch(handleCheckoutHybridDelivery(finalPayloadDelivery)).unwrap();

            if (resDelivery?.status === 403) {
                dispatch(setIsSubmiting(true));
                setOpenUnverifiedPhone(true);
                handleOnClose();
                return toast.error(resDelivery?.message);
            }

            setDeliveryFeeLoadingGift(false);
            // setCouponCodeGift("");
            return setHybridDeliveryFeeGift(resDelivery);
        } catch (err) {
            return err;
        }
    }, [customerId, dispatch, handleXmlGiftCart, isCouponGift]);

    // ================================================================ UseEffect Declarations =========================================

    // Handle the delivery charge calculations =================================== Personal =========
    useEffect(() => {
        if ((fetchedCart?.items?.length || customBasket?.line_items?.length) && !personalCartIsCleared) {
            calculatePersonalDeliveryFees(fetchedCart, customBasket);
        }
    }, [fetchedCart, customBasket, calculatePersonalDeliveryFees, isCoupon, personalCartIsCleared]);

    // Handle the delivery charge calculations =================================== Gift =========
    useEffect(() => {
        if (customGiftFoodBasket?.line_items?.length || customGiftBasket?.line_items?.length) {
            calculateGiftDeliveryFees(customGiftFoodBasket, customGiftBasket);
        }
    }, [customGiftFoodBasket, customGiftBasket, calculateGiftDeliveryFees, isCouponGift]);

    // Clear the deliveryFees
    useEffect(() => {
        if (personalCartIsCleared && !customBasket?.line_items?.length) {
            setHybridDeliveryFee({});
        }
    }, [personalCartIsCleared, customBasket]);

    useEffect(() => {
        if (!customGiftBasket?.line_items?.length && !customGiftFoodBasket?.line_items?.length) {
            setHybridDeliveryFeeGift({});
        }
    }, [customGiftBasket, customGiftFoodBasket]);

    useEffect(() => {
        const isFrom = localStorage.getItem('isFrom')
        if (isFrom !== null) {
            setTabIndex(isFrom === "gift" ? 1 : 0)
            setIsViewingIndex(isFrom === "gift" ? 0 : 1)
        }
    }, []);

    useEffect(() => {
        handleFetchSavedDelivery();
    }, []);

    useEffect(() => {
        if (customGiftBasket?.line_items?.length) {
            customGiftBasket?.line_items?.map((lineIt) => {
                if (
                    lineIt?.item_id === "GROBP" ||
                    lineIt?.item_id === "GROSP" ||
                    lineIt?.item_id === "GROGP" ||
                    lineIt?.item_id === "GRODP" ||
                    lineIt?.item_id === "GROPP"
                ) {
                    return removeCustomGiftBasket();
                }
                return null;
            });
        }
    }, [customGiftBasket?.line_items, removeCustomGiftBasket]);

    useEffect(() => {
        if (customGiftFoodBasket?.line_items?.length) {
            customGiftFoodBasket?.line_items?.map((lineIt) => {
                if (
                    lineIt?.item_id !== "GROBP" &&
                    lineIt?.item_id !== "GROSP" &&
                    lineIt?.item_id !== "GROGP" &&
                    lineIt?.item_id !== "GRODP" &&
                    lineIt?.item_id !== "GROPP"
                ) {

                    return removeCustomGiftFoodBasket();
                }
                return null;
            });
        }
    }, [customGiftFoodBasket?.line_items, removeCustomGiftFoodBasket]);

    useEffect(() => {
        if (customBasket?.line_items?.length) {
            handleRecommendations(customBasket?.line_items);
        }
    }, [customBasket?.line_items, handleRecommendations]);

    useEffect(() => {
        if (customGiftBasket?.line_items?.length) {
            handleRecommendations(customGiftBasket?.line_items);
        }
    }, [customGiftBasket?.line_items, handleRecommendations]);

    useEffect(() => {
        if (!todoListStatusData) {
            const data = {
                sql_ref_no: "20",
                user_id: userId.toString(),
                verification_code: verification_code?.toString(),
                option: "1",
            };

            dispatch(todoListStatus(data));
        }

        if (todoListStatusData) setfetchedStatuses(todoListStatusData);
    }, [dispatch, todoListStatusData, verification_code, userId]);

    useEffect(() => {
        if (!grocedyForAll) {
            dispatch(fetchGrocedyForAll(customerId ? customerId : "0"))
                .unwrap()
                .catch((err) => {
                    navigate("/login");

                    return err;
                });
        }

        if (grocedyForAll && grocedyForAll?.delivery_charge?.length) {
            setFetchedDeliveryCharge(grocedyForAll?.delivery_charge);
        }
    }, [grocedyForAll, navigate, customerId, dispatch]);

    useEffect(() => {
        if (grocedyForAll && grocedyForAll?.delivery_charge?.length) {
            setFetchedDeliveryCharge(grocedyForAll?.delivery_charge);
        }
    }, [dispatch, grocedyForAll, navigate]);

    useEffect(() => {
        const data = {
            user_email: userEmail,
        };

        dispatch(productPurchaseGet(data));
    }, [userEmail, dispatch]);

    useEffect(() => {
        if (!walletBalance) {
            const data = {
                sql_ref_no: "31",
                user_id: userId?.toString(),
                customer_id: customerId?.toString(),
                verification_code,
                option: "1",
            };
            dispatch(getWalletBalance(data))
                .unwrap()
                .catch((err) => {
                    return err;
                });
        }

        if (walletBalance) setFetchedUserBalance(walletBalance);
    }, [dispatch, userId, customerId, verification_code, walletBalance]);

    useEffect(() => {
        if (!cart?.items?.length) {
            // setCouponCode("");
            dispatch(resetCoupon());
            setSubTotalPlanPrice(0);
            setSubTotalAddonPrice(0);
        }
    }, [cart?.items?.length, dispatch]);

    // Merge local cart to mongo cart
    useEffect(() => {
        if (token && copyCartObj?.length) {
            localStorage.removeItem("cart");

            const modifiedLocalCartObject =
                updatedLocalCart?.length &&
                updatedLocalCart?.map((cartObj) => ({
                    itemId: cartObj?.itemId,
                    sql_ref_no: "25",
                    user_email: userEmail,
                    JSON_String: {
                        customer_id: customerId.toString(),
                        plan: {
                            plan_name: cartObj?.JSON_String?.plan?.plan_name,
                            plan_quantity: cartObj?.JSON_String?.plan?.plan_quantity,
                            plan_price: cartObj?.JSON_String?.plan?.plan_price,
                            plan_code: cartObj?.JSON_String?.plan?.plan_code,
                            isRecurring: cartObj?.JSON_String?.plan?.isRecurring,
                            product_id: cartObj?.JSON_String?.plan?.product_id,
                            interval: "1",
                            interval_unit: "months",
                            number_of_months: cartObj?.JSON_String?.plan?.number_of_months,
                        },
                        addons: cartObj?.JSON_String?.addons,
                    },
                }));

            setModifiedLocalCart(modifiedLocalCartObject);
        }
    }, [token, copyCartObj, userEmail, customerId, dispatch, updatedLocalCart]);

    // Send the latest cart items
    useEffect(() => {
        if (modifiedLocalCart && modifiedLocalCart?.length) {
            const cartPromise = new Promise((reslove) => {
                modifiedLocalCart.map(async (item) => {
                    reslove(dispatch(productPurchaseSet(item)));
                });
            });

            Promise.all([cartPromise])
                .then(() => {
                    toast.success("Cart Updated Successfully");
                    setModifiedLocalCart([]);
                })
                .catch((err) => {
                    toast.error("Something Went Wrong!");

                    return err;
                });
        }
    }, [updatedLocalCart, dispatch, modifiedLocalCart]);

    // Fetch the cart information (Authenticated User)
    useEffect(() => {
        if (!customGiftBasket?.line_items?.length &&
            !customGiftFoodBasket?.line_items?.length
        ) {
            setHybridDeliveryFeeGift({});
        }
    }, [
        customGiftBasket,
        customGiftFoodBasket
    ]);

    useEffect(() => {
        if (fetchedCart?.items?.length) {
            const planTotal = calculateTotalPlansQty(fetchedCart?.items);

            setTotalPlansQty(planTotal);
        }
    }, [fetchedCart?.items?.length]);

    useEffect(() => {
        if (customGiftFoodBasket?.line_items?.length) {
            const giftPlanTotal = calculateTotalGiftPlansQty(customGiftFoodBasket?.line_items);


            setTotalGiftPlansQty(giftPlanTotal);
        }
    }, [customGiftFoodBasket?.line_items?.length]);

    // Fetch the cart information (Authenticated User)
    useEffect(() => {
        if (!cart && userEmail && token) {
            const data = {
                user_email: userEmail,
            };

            dispatch(productPurchaseGet(data));
        }

        if (cart?.items && token) {
            setFetchedCart(cart);
        }

        if (
            !cart?.items?.length &&
            !customBasket?.line_items?.length &&
            !updatedLocalCart?.length
        ) {
            setSubTotalPlanPrice(0);
            setHybridDeliveryFee({});
            setSubTotalAddonPrice(0);
        }
    }, [
        dispatch,
        cart,
        cart?.items,
        userEmail,
        token,
        customBasket,
        updatedLocalCart,
    ]);


    // The total Price of plan
    useEffect(() => {
        if (fetchedCart?.items?.length) {
            const totalBasketPrice = fetchedCart?.items?.map(
                (tArray) =>
                    +tArray?.JSON_String?.plan?.plan_price *
                    +tArray?.JSON_String?.plan?.plan_quantity
            );

            const subtotalBasketPrice =
                totalBasketPrice &&
                totalBasketPrice?.length &&
                totalBasketPrice?.reduce((a, b) => a + b);

            setSubTotalPlanPrice(subtotalBasketPrice);
        }
    }, [fetchedCart]);

    useEffect(() => {
        if (!fetchedCart?.items?.length && updatedLocalCart?.length) {
            const totalBasketPrice = updatedLocalCart?.map(
                (tArray) =>
                    +tArray?.JSON_String?.plan?.plan_price *
                    +tArray?.JSON_String?.plan?.plan_quantity
            );

            const subtotalBasketPrice =
                totalBasketPrice &&
                totalBasketPrice?.length &&
                totalBasketPrice?.reduce((a, b) => a + b);

            setSubTotalOfflinefPlanPrice(subtotalBasketPrice);
        }
    }, [fetchedCart?.items, updatedLocalCart]);

    // Total Price for addOns
    useEffect(() => {
        if (fetchedCart?.items?.length) {
            const totalAddonPrice = fetchedCart?.items?.map((tArray) =>
                tArray?.JSON_String?.addons.length
                    ? tArray?.JSON_String?.addons?.map(
                        (addOn) => addOn?.price_brackets?.totalPrice
                    )
                    : 0
            );

            const merged = [].concat.apply([], totalAddonPrice);

            const subtotalAddonPrice =
                merged && merged?.length && merged?.reduce((a, b) => a + b);

            setSubTotalAddonPrice(subtotalAddonPrice);
        }
    }, [fetchedCart?.items]);

    useEffect(() => {
        if (!fetchedCart?.items?.length && updatedLocalCart?.length) {
            const totalAddonPrice = updatedLocalCart?.map((tArray) =>
                tArray?.JSON_String?.addons?.length
                    ? tArray?.JSON_String?.addons?.map(
                        (addOn) => addOn?.price_brackets?.totalPrice
                    )
                    : []
            );

            const merged = [].concat.apply([], totalAddonPrice);

            const subtotalAddonPrice =
                merged && merged?.length && merged?.reduce((a, b) => a + b);

            setSubTotalOfflineAddonPrice(subtotalAddonPrice);
        }
    }, [fetchedCart?.items, updatedLocalCart]);

    // add the fetched plans to state
    useEffect(() => {
        if (selected_plan) {
            const filteredProductPlans = grocedyForAll?.plan_info?.filter(
                (plan) => plan?.product_id === selected_plan
            );

            setFetchedPlans(filteredProductPlans);
        }
    }, [selected_plan, grocedyForAll?.plan_info]);

    // Fetch the countries
    useEffect(() => {
        if (!fetchCountriesData && token) {
            const data = {
                sql_ref_no: "12",
                user_id: userId.toString(),
                c_code: verification_code,
                option: "19",
            };

            dispatch(fetchCountries(data));
        }

        if (fetchCountriesData)
            setFetchedCountries(fetchCountriesData.location_info);
    }, [fetchCountriesData, userId, verification_code, dispatch, token]);

    // Set the countries into state
    useEffect(() => {
        if (fetchedCountries) {
            const resArr = [];
            fetchedCountries.filter((item) => {
                let i = resArr.findIndex((x) => x === item.country_name);
                if (i <= -1) {
                    resArr.push(item.country_name);
                }
                return null;
            });

            setCountries(resArr);
        }
    }, [fetchedCountries]);

    // Get the exist
    useEffect(() => {
        if (!getDeliveryItems && token) {
            const data = {
                sql_ref_no: "11",
                user_id: userId.toString(),
                customer_id: customerId.toString(),
                option: "6",
            };

            dispatch(getDelivery(data));
        }

        if (getDeliveryItems) setExistingDeliveryInfo(getDeliveryItems);
    }, [getDeliveryItems, dispatch, userId, customerId, token]);

    useEffect(() => {
        dispatch(resetCoupon());
    }, [dispatch]);

    //  For custom basket
    useEffect(() => {
        let tempCustomBasket = {
            plan_name: "Custom Basket",
            notes: "",
            discount: "00.00%",
            customer_id: authService.getCurrentUserZohoCustomerId(),
            shipping_charge: 0,
            adjustment: 0,
            adjustment_description: "custom basket item",
            exchange_rate: 1,
            line_items: [],
        };

        rxjsStore.getUserSelectedBasket().subscribe((productsListMap) => {
            for (let [key, product] of productsListMap) {
                const tempItems = {
                    item_id: product.item_id,
                    name: product.name,
                    rate: product.item_rate_zoho,
                    quantity: product.qty,
                    unit: product.unit,
                    type: product?.type,
                    sku: product.sku,
                    item_total: product.qty * Number(product.item_rate_zoho),
                };
                tempCustomBasket.line_items.push(tempItems);
            }
            setCounter((prev) => {
                return prev + 1;
            });
            setCustomBasket(tempCustomBasket);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //  For custom gift basket
    useEffect(() => {
        let tempCustomBasket = {
            plan_name: "Custom Gift Basket",
            notes: "",
            discount: "00.00%",
            customer_id: authService.getCurrentUserZohoCustomerId(),
            shipping_charge: 0,
            adjustment: 0,
            adjustment_description: "custom basket item",
            exchange_rate: 1,
            line_items: [],
        };

        rxjsGiftStore.getUserSelectedBasket().subscribe((productsListMap) => {
            for (let [key, product] of productsListMap) {
                const tempItems = {
                    item_id: product.item_id,
                    name: product.name,
                    rate: product.item_rate_zoho,
                    quantity: product.qty,
                    unit: product.unit,
                    type: product?.type,
                    sku: product.sku,
                    item_total: product.qty * Number(product.item_rate_zoho),
                };
                tempCustomBasket.line_items.push(tempItems);
            }
            setGiftCounter((prev) => {
                return prev + 1;
            });
            setCustomGiftBasket(tempCustomBasket);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //  For gift food basket basket
    useEffect(() => {
        let tempCustomBasket = {
            plan_name: "Gift Food Basket",
            notes: "",
            discount: "00.00%",
            customer_id: authService.getCurrentUserZohoCustomerId(),
            shipping_charge: 0,
            adjustment: 0,
            adjustment_description: "gift food basket item",
            exchange_rate: 1,
            line_items: [],
        };

        rxjsFoodBasketStore.getUserSelectedBasket().subscribe((productsListMap) => {
            for (let [key, product] of productsListMap) {
                const tempItems = {
                    item_id: product.item_id,
                    name: product.name,
                    rate: product.item_rate_zoho,
                    quantity: product.qty,
                    unit: "",
                    type: "Gift Food Basket",
                    sku: product.sku,
                    item_total: product.qty * Number(product.item_rate_zoho),
                };
                tempCustomBasket.line_items.push(tempItems);
            }
            setGiftFoodBasketCounter((prev) => {
                return prev + 1;
            });
            setCustomGiftFoodBasket(tempCustomBasket);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(updatedLocalCart));
    }, [updatedLocalCart]);

    return (
        <>
            <SignedInNavbarImproved />
            <div className='relative h-32 w-full bg-gradient-to-r from-[#558223]/60 via-[#558223]/70 to-[#558223]'>
                <div className='text-[clamp(0.7rem,1.4vw,1rem)]'></div>
                <div className='absolute left-0 bottom-0'><img src={WrapOne} alt='' className='h-6 sm:h-8 w-auto' /></div>
                <div className='absolute left-1/2 bottom-0'><img src={WrapTwo} alt='' className='h-14 sm:h-20 w-auto' /></div>
                <div className='absolute inset-0'>
                    <div className='mx-auto max-w-[1600px] px-3 xsm:px-4 sm:px-8 lg:px-14 flex flex-row items-center justify-between h-full'>
                        <div className='w-4/5 mr-4'>
                            <h1 className='text-[min(3.5vw,25px)] font-semibold text-white leading-tight max-w-xl'>Want to send food items to multiple recipients?</h1>
                            <p className='text-[min(2.2vw,15px)] font-semibold text-white'>You can do that on our mobile app</p>
                            <a href="https://download.grocedy.com/u/12811202 " target="_blank" rel="noopener noreferrer">
                                <button className='mt-1.5 px-2 sm:px-4 py-2 sm:py-2 rounded-md bg-white text-xs sm:text-sm font-medium text-[#558223] hover:bg-gray-100'>Download Mobile App</button>
                            </a>
                        </div>
                        <div className='w-1/2 flex items-center justify-end lg:mr-10'><img src={WrapThree} alt='' className='h-full max-h-[90px] w-auto' /></div>
                    </div>
                </div>
            </div>
            <div className="mx-auto max-w-[1600px] bg-[#F5F5F5] lg:grid lg:grid-cols-9">
                <div className="pb-20 lg:pb-40 px-3 xsm:px-4 sm:px-8 lg:px-14 lg:col-span-6 @container">
                    <div className="mt-14 flex flex-row text-3xl font-bold text-[#558223]">
                        <span>Cart</span>
                        <Tooltip title="Cart Page">
                            <span className='ml-1 mt-1'>
                                <IoInformationCircleSharp className='h-8 w-8 text-[#558223]' />
                            </span>
                        </Tooltip>
                    </div>
                    <div className='mt-6'>
                        <Tab.Group selectedIndex={tabIndex} onChange={handleTabChange}>
                            <Tab.List className="flex space-x-2 border-b border-gray-200">
                                {({ selectedIndex }) => (
                                    <>
                                        <Tab
                                            className={({ selected }) =>
                                                `px-4 py-2 text-sm font-medium transition-colors focus:outline-none ${selected
                                                    ? 'text-[#558223] border-b-[1.5px] border-[#558223]'
                                                    : 'text-gray-500 border-b-[1.5px] border-transparent'
                                                }`
                                            }
                                            onClick={() => setIsViewingIndex(selectedIndex)}
                                        >
                                            <span className='@sm:hidden'>Your Personal Cart</span><span className='hidden @sm:inline'>My Cart</span>
                                        </Tab>
                                        <Tab
                                            className={({ selected }) =>
                                                `px-4 py-2 text-sm font-medium transition-colors focus:outline-none ${selected
                                                    ? 'text-[#558223] border-b-[1.5px] border-[#558223] '
                                                    : 'text-gray-500 border-b-[1.5px] border-transparent'
                                                }`
                                            }
                                            onClick={() => setIsViewingIndex(selectedIndex)}
                                        >
                                            <span className='@sm:hidden'>Your Gift Cart</span><span className='hidden @sm:inline'>Gift Cart</span>
                                        </Tab>
                                    </>
                                )}
                            </Tab.List>

                            <Tab.Panels className="mt-4 relative" unmount={false}>
                                {/* Fade Animation Panel */}
                                <Tab.Panel>
                                    {({ selected }) => (
                                        <Transition
                                            show={selected}
                                            enter="transition-opacity duration-300 ease-out"
                                            enterFrom="opacity-0"
                                            enterTo="opacity-100"
                                            leave="transition-opacity duration-300 ease-in"
                                            leaveFrom="opacity-100"
                                            leaveTo="opacity-0"
                                        >
                                            <MyCartCheckout
                                                setOpenGiftModal={setOpenGiftModal}
                                                fetchedCart={fetchedCart}
                                                handleDelete={handleDelete}
                                                fetchedPlans={fetchedPlans}
                                                setTotalPlansQty={setTotalPlansQty}
                                                calculateTotalPlansQty={calculateTotalPlansQty}
                                                customBasket={customBasket}
                                                removeCustomBasket={removeCustomBasket}
                                                customBasketIsRecurring={customBasketIsRecurring}
                                                calculateTotalBasket={calculateTotalBasket}
                                                customIsInfinite={customIsInfinite}
                                                setBasketRecurr={setBasketRecurr}
                                                count={count}
                                                setCount={setCount}
                                            />
                                        </Transition>
                                    )}
                                </Tab.Panel>

                                {/* Slide Animation Panel */}
                                <Tab.Panel>
                                    {({ selected }) => (
                                        <Transition
                                            show={selected}
                                            enter="transition-all duration-300 ease-out"
                                            enterFrom="opacity-0 translate-y-4"
                                            enterTo="opacity-100 translate-y-0"
                                            leave="transition-all duration-300 ease-in"
                                            leaveFrom="opacity-100 translate-y-0"
                                            leaveTo="opacity-0 -translate-y-4"
                                        >
                                            <GiftCartCheckout
                                                handleViewReceipient={handleViewReceipient}
                                                customGiftBasket={customGiftBasket}
                                                countGiftCustom={countGiftCustom}
                                                setCountGiftCustom={setCountGiftCustom}
                                                giftCustomIsRecurring={giftCustomIsRecurring}
                                                giftCustomIsInfinite={giftCustomIsInfinite}
                                                calculateTotalBasket={calculateTotalBasket}
                                                removeCustomGiftBasket={removeCustomGiftBasket}
                                                handleDelete={handleDelete}
                                                handleViewFoodBasketReceipient={handleViewFoodBasketReceipient}
                                                customGiftFoodBasket={customGiftFoodBasket}
                                                countGiftFb={countGiftFb}
                                                setCountGiftFb={setCountGiftFb}
                                                giftFoodBasketIsInfinite={giftFoodBasketIsInfinite}
                                                giftFoodBasketIsRecurring={giftFoodBasketIsRecurring}
                                                removeCustomGiftFoodBasket={removeCustomGiftFoodBasket}
                                                setOpenGiftItemModal={setOpenGiftItemModal}
                                                setBasketType={setBasketType}
                                            />
                                        </Transition>
                                    )}
                                </Tab.Panel>
                            </Tab.Panels>
                        </Tab.Group>
                    </div>
                </div>

                {isViewingIndex === 1 && (
                    <MyCartSummary
                        fetchedCart={fetchedCart}
                        customBasket={customBasket}
                        calculateTotalBasket={calculateTotalBasket}
                        handleCouponVerify={handleCouponVerify}
                        setCouponCode={setCouponCode}
                        couponCode={couponCode}
                        handleGeneralCheckout={handleGeneralCheckout}
                        priceAlert={priceAlert}
                        showPriceAlert={showPriceAlert}
                        hybridDeliveryFee={hybridDeliveryFee}
                        deliveryFeeLoading={deliveryFeeLoading}
                    />
                )}

                {isViewingIndex === 0 && (
                    <GiftCartSummary
                        customGiftFoodBasket={customGiftFoodBasket}
                        calculateTotalBasket={calculateTotalBasket}
                        customGiftBasket={customGiftBasket}
                        handleCouponVerifyGift={handleCouponVerifyGift}
                        setCouponCodeGift={setCouponCodeGift}
                        couponCodeGift={couponCodeGift}
                        handleGiftGeneralCheckout={handleGiftGeneralCheckout}
                        priceAlertGift={priceAlertGift}
                        showPriceAlertGift={showPriceAlertGift}
                        hybridDeliveryFeeGift={hybridDeliveryFeeGift}
                        deliveryFeeLoadingGift={deliveryFeeLoadingGift}
                    />
                )}
                <div>
                    <GiftModal
                        openGiftModal={openGiftModal}
                        setOpenGiftModal={setOpenGiftModal}
                        selectedOption={selectedOption}
                        handleSelect={handleSelect}
                    />
                </div>

                <div>
                    <GiftItemModal
                        openGiftItemModal={openGiftItemModal}
                        setOpenGiftItemModal={setOpenGiftItemModal}
                        selectedGiftOption={selectedGiftOption}
                        handleSelectGiftItem={handleSelectGiftItem}
                    />
                </div>

                <div>
                    <CustomGiftRecipientDetailsModal
                        openCustomGiftRecipientDetailsModal={openCustomGiftRecipientDetailsModal}
                        setOpenCustomGiftRecipientDetailsModal={setOpenCustomGiftRecipientDetailsModal}
                        fetchedCustomGiftReceipient={fetchedCustomGiftReceipient}
                        changeRecipient={changeRecipientFB}
                        setBasketType={setBasketType}
                    />
                </div>

                <div>
                    <FBGiftRecipientModal
                        openFoodBasketGiftRecipientDetailsModal={openFoodBasketGiftRecipientDetailsModal}
                        setOpenFoodBasketGiftRecipientDetailsModal={setOpenFoodBasketGiftRecipientDetailsModal}
                        fetchedCustomGiftReceipient={fetchedCustomGiftReceipient}
                        changeRecipient={changeRecipientFB}
                        setBasketType={setBasketType}
                    />
                </div>

                <div>
                    <ChangeRecipient
                        openRecipientDetailsModal={openRecipientDetailsModal}
                        setOpenRecipientDetailsModal={setOpenRecipientDetailsModal}
                        fetchedExistingAddress={fetchedExistingAddress}
                        basketType={basketType}
                    />
                </div>
            </div>
            <Modal
                visible={showModal}
                onClose={handleOnClose}
                selected={selectedModal}
                cartAmount={
                    isViewingIndex === 1 ?
                        hybridDeliveryFee?.amount_information?.length && hybridDeliveryFee?.amount_information[0]?.grand_total_amount :
                        hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.grand_total_amount
                }
                paymentProceed={isViewingIndex === 1 ? handlePersonalSubmission : handleGiftSubmission}
            />

            <MUIModal
                open={openCustomRating}
                onClose={() => setOpenCustomRating(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="mt-6 overflow-hidden px-2 xsm:px-4">
                    <Box className="mx-auto max-w-lg rounded-md bg-[#FEFEFD] p-4 shadow shadow-gray-500">
                        <FeedBackRatingPopup
                            setOpen={setOpenCustomRating}
                            type="shopping"
                            subscriptionId={subRef}
                        />
                    </Box>
                </div>
            </MUIModal>
        </>
    )
}

export default CheckoutPage